export function getId<T extends string | Readonly<{ id: string }>>(
  obj: T,
  fallbackValue?: string | null,
): string;
export function getId<T>(obj: T, fallbackValue?: string | null): string | null;
export function getId(obj: unknown, fallbackValue: string | null = null): string | null {
  if (typeof obj === 'string') {
    return obj;
  }
  if (obj && typeof obj === 'object' && 'id' in obj && typeof obj.id === 'string') {
    return obj.id;
  }
  return fallbackValue;
}
